import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ShareService {
  heightService: number;
  notify_obj: any;
  adminComp: any;
  fieldObj: any;
  gpObj: any;
  csv_obj: any;
  fieldShuffleDialog:any;
  qaqc_obj:any;
  unit_map_obj:any;
  appComp:any;

  private progressStartedSource = new BehaviorSubject<boolean>(false);
  public dataDownload$ = this.progressStartedSource.asObservable();

  progress = new BehaviorSubject<any>(null);
  quick_edit_count = new BehaviorSubject<any>(0);
  constructor() { }

  dataDownloadProgress(value: boolean) {
    this.progressStartedSource.next(value);
  }
}
